export default "__VITE_ASSET__CtwtZ_9S__"